import React from 'react';
import styled from '@emotion/styled';
import { Result } from '../types';
import { NumericFormat } from 'react-number-format';

const OuterBox = styled.div`
  box-shadow: 0px 12px 24px -4px rgba(145, 158, 171, 0.12);
  border-radius: 6px;
  width: 440px;
  margin-top: 8px;
`;
const InnerBox = styled.div`
  padding: 8px 16px;
`;
const HeaderInfo = styled.div`
  font-weight: bold;
  margin-top: 30px;
  background: #f7f7f9;
  border-radius: 6px 6px 0px 0px;
  padding: 24px 16px;
  font-size: 18px;
  border-bottom: 1px solid #E5E5EA;
`;
interface Props{
    property: Result;
  }
const AssessmentInformation = (props:Props) => {
  return (
    <>
      <OuterBox>
      <HeaderInfo style={{ fontWeight: 'bold', marginTop: 30 }}>Assessment Data</HeaderInfo>
        <InnerBox>
          <div style={{ color: '#8E8E93' }}>Land Value</div>
          <NumericFormat value={parseInt(props.property?.landValue)} displayType={'text'} thousandSeparator={true} prefix={'$'}/>
        </InnerBox>
        {props.property?.improvement && <InnerBox>
          <div style={{ color: '#8E8E93' }}>Improvement</div>
          <NumericFormat value={parseInt(props.property?.improvement)} displayType={'text'} thousandSeparator={true} prefix={'$'}/>
        </InnerBox>}
        <InnerBox>
          <div style={{ color: '#8E8E93' }}>Total</div>
          <NumericFormat value={parseInt(props.property?.total)} displayType={'text'} thousandSeparator={true} prefix={'$'}/>
        </InnerBox>
        
      </OuterBox>
    </>
  );
};

export default AssessmentInformation;
